import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { AdvancedSearchParameter, AdvancedSearchService } from "../advanced-search.service";

@Component({
    selector: "advanced-search-list",
    imports: [NgClass, SvgIconComponent],
    templateUrl: "./advanced-search-list.component.html"
})
export class AdvancedSearchListComponent {
    @ViewChild("selectInput") private selectInputRef!: ElementRef<HTMLInputElement>;

    @Input({ required: true }) public type!: AdvancedSearchParameter;
    @Input({ required: true }) public items!: string[];
    
    public hasValue: boolean = false;
    public closeSvgIcon: SvgIcon = SvgIcon.Close;

    public selectedIndex?: number;
    
    public constructor(private advancedSearch: AdvancedSearchService) {

    }

    public onChange(value: string): void {
        const valueNumber = +value;

        if (valueNumber >= 0) {
            this.hasValue = true;
            this.selectedIndex = valueNumber;
            this.advancedSearch.setString(this.type, this.items[this.selectedIndex]);
        } else {
            this.onClear();
        }
    }

    public onClear(): void {
        this.hasValue = false;
        this.selectedIndex = undefined;
        this.selectInputRef.nativeElement.value = "-1";
        this.advancedSearch.setString(this.type, undefined);
    }
}